import React, { useEffect, useState } from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import * as createHistory from 'history';
import { Provider } from 'react-redux';
import { injectStyle } from 'react-toastify/dist/inject-style';

import theme from './styles/theme';
import Router from './router';
import combineProviders from './context/CombinedContextProvider';
import { store } from './services/redux/store';

import './languages/i18n';
import './services/firebase';
import ErrorBoundary from './components/reusable/error-boundary/ErrorBoundary';
import ToastRoot from './components/layout/toast-root/ToastRoot';
import { waitForAuthInit } from './services/firebase';

const history = createHistory.createBrowserHistory();
const AppContextProvider = combineProviders();

function App() {
  const [firebaseAuthInited, setFirebaseAuthInited] = useState(false);

  useEffect(() => {
    injectStyle();
    waitForAuthInit().then(() => {
      setFirebaseAuthInited(true);
    });
  }, []);

  if (!firebaseAuthInited) return null;

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <StyledEngineProvider injectFirst>
            <AppContextProvider>
              <Router history={history} />
            </AppContextProvider>
            <ToastRoot />
          </StyledEngineProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
